// Import Firebase
import { initializeApp } from "firebase/app";

// Import services
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBgGbZaQwVsKKNEESaQmSb2FLFNA7VbTqY",
  authDomain: "dealership-32993.firebaseapp.com",
  projectId: "dealership-32993",
  storageBucket: "dealership-32993.appspot.com", 
  messagingSenderId: "144837653313",
  appId: "1:144837653313:web:bcda9aef2b36f135d927c0",
  measurementId: "G-MGEZSRYZ9Y"
};

// Initialize app
const app = initializeApp(firebaseConfig);

// 🔥 EXPORT EVERYTHING YOU NEED
export const auth = getAuth(app);        // ✅ THIS WAS MISSING
export const db = getFirestore(app);
export const storage = getStorage(app);

// optional default
export default app;